// @flow
import { toFiniteNumber } from '../../../utils/numbers';

// The size the income limits are read against: everyone the agent counted,
// adults and minors alike. A household of 0 has no column on that table.
export const toHouseholdSize = (adults: mixed, minors: mixed): number =>
  (toFiniteNumber(adults) ?? 0) + (toFiniteNumber(minors) ?? 0);
